import { Config } from '@generated/models';

export const isDeliveryEnabled = (config: Config): boolean => config.featureFlags?.delivery_enable === true;
